var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useContext } from 'react';
import { AuthProviderContext } from './AuthProviderContext';
export const useAuthProvider = () => {
    _react_refresh_temp_1();
    const authProviderContextValue = useContext(AuthProviderContext);
    if (!authProviderContextValue) {
        throw new Error('AuthProvider context not available!');
    }
    return authProviderContextValue;
};
_react_refresh_temp_1(useAuthProvider, "NU2UgHg4k28aDlHhRN3YLl8OjVU=");
